import { SupportSettingWidgetModel } from '~/site/model/models/supportSettingWidgetModel'
import { DialogWidgetModel } from '~/site/model/models/DialogWidgetModel'
import { MissionCenterSettingModel } from '~/site/model/models/MissionCenterSettingModel'

export const SiteEnum = {
  BASE_PAGE: 'home',
  BASE_PAGE_ID: 0
}

export const NavTypeEnum = {
  URL: '1',
  PAGE: '2',
  MODEL: '3'
}

export const SiteColumnsNameEnum = {
  PAGE: '页面',
  LOGIN: '登陆',
  SEO: 'SEO',
  THEME: '主题',
  ASSETS: '素材库',
  LANGUAGE: '语言',
  SETTING: '配置',
  GLOBAL: '全局'
}

export const PageSetting = {
  getMenuInfo() {
    return {
      icon: 'pageSvg',
      name: SiteColumnsNameEnum.PAGE
    }
  }
}

export const LoginSetting = {
  children: [
    //
  ],
  getMenuInfo() {
    return {
      icon: 'icon-login-nor',
      name: SiteColumnsNameEnum.LOGIN
    }
  }
}

export const GlobalSetting = {
  children: [
    {
      name: SiteColumnsNameEnum.ASSETS
    },
    {
      name: SiteColumnsNameEnum.GLOBAL
    },
    {
      name: SiteColumnsNameEnum.LANGUAGE
    },
    {
      name: SiteColumnsNameEnum.SEO
    }
  ],
  getMenuInfo() {
    return {
      icon: 'iconGlobal',
      name: SiteColumnsNameEnum.GLOBAL
    }
  }
}

export const ColumnsSetting = [
  PageSetting,
  LoginSetting,
  GlobalSetting
]

export const InterCurrency = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'IDR', 'HKD', 'TWD']

export const RechargeAnyValueId = "9999"

export const EventCodeEnums = {
  STORE_VISITED: 'STORE_VISITED',
  EMAIL_LOGIN_SHOW: 'EMAIL_LOGIN_SHOW',
  EMAIL_BIND_UID: 'EMAIL_BIND_UID',
  UID_LOGIN_SHOW: 'UID_LOGIN_SHOW',
  UID_LOGIN: 'UID_LOGIN',
  PAYMENT_SHOW: 'PAYMENT_SHOW',
  EMAIL_LOGIN: 'EMAIL_LOGIN',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  PAYMENT_CHOOSE: 'PAYMENT_CHOOSE',
  PAYMENT_SUBMIT: 'PAYMENT_SUBMIT',
  PAYMENT_MIDDLE_SHOW: 'PAYMENT_MIDDLE_SHOW',
  ORDER_SHOW: 'ORDER_SHOW',
  PWA_INSTALL: 'PWA_INSTALL'
}

export const ModuleNameEnum = {
  CustomerService: '客服',
  Dialog: '弹窗',
  MissionCenter: '任务中心',
  DialogCollection: '弹窗集',
  Consecutive: '连续充值',
  Carousel: '轮播图',
  Collapse: '折叠内容',
  QuenUnlock: '顺序解锁购买',
  StandaloneProduct: '独立商品'
}

export const ModuleTitleEnum = {
  DialogCollection: 'dialogCollection',
  DialogItem: 'dialogItem'
}

export const DialogShowTypeValueEnums = {
  immediate: 1,
  uidEveryday: 2,
  deviceEveryDay: 3,
  uidOnce: 4
}

export const DialogShowTypeEnums = [
  {
    label: '开屏即显示',
    value: DialogShowTypeValueEnums.immediate
  },
  {
    label: 'UID每天一次',
    value: DialogShowTypeValueEnums.uidEveryday
  },
  {
    label: '设备每天一次',
    value: DialogShowTypeValueEnums.deviceEveryDay
  },
  {
    label: '[UID+设备]终身一次',
    value: DialogShowTypeValueEnums.uidOnce
  }
]

export const SpeModuleModelNames = [
  SupportSettingWidgetModel.name,
  DialogWidgetModel.name,
  MissionCenterSettingModel.name
]

export const WidgetModelNames = {
  ActivityWidgetModel: 'ActivityWidgetModel',
  SignActivityWidgetModel: 'SignActivityWidgetModel',
  ConvertKeyWidgetModel: 'ConvertKeyWidgetModel',
  ConvertKeyWidgetV2Model: 'ConvertKeyWidgetV2Model',
  ConsecutiveWidgetModel: 'ConsecutiveWidgetModel',
  LotteryWidgetModel: 'LotteryWidgetModel',
  MonthCardWidgetModel: 'MonthCardWidgetModel',
  DialogCollectionWidgetModel: 'DialogCollectionWidgetModel',
  MissionCenterSettingModel: 'MissionCenterSettingModel',
  SupportSettingWidgetModel: 'SupportSettingWidgetModel',
  DialogItemWidgetModel: 'DialogItemWidgetModel',
  FooterQuickLinkWidgetModel: 'FooterQuickLinkWidgetModel',
  FooterTextWidgetModel: 'FooterTextWidgetModel',
  FooterMediaWidgetModel: 'FooterMediaWidgetModel',
  FooterWidgetModel: 'FooterWidgetModel',
  RechargeWidgetV3Model: 'RechargeWidgetV3Model',
  HeaderWidgetModel: 'HeaderWidgetModel',
  CarouselWidgetModel: 'CarouselWidgetModel',
  ImageTextItemWidgetModel: 'ImageTextItemWidgetModel',
  CollapseWidgetModel: 'CollapseWidgetModel',
  QuenUnlockWidgetModel: 'QuenUnlockWidgetModel',
  StandaloneProductWidgetModel: 'StandaloneProductWidgetModel',
}

export const SettingModelNames = {
  LoginSettingModel: 'LoginSettingModel',
  GlobalSettingModel: 'GlobalSettingModel',
  LangSettingModel: 'LangSettingModel',
  ModuleNavigationWidgetModel: 'ModuleNavigationWidgetModel',
  PwaWidgetModel: 'PwaWidgetModel',
  [WidgetModelNames.MissionCenterSettingModel]: WidgetModelNames.MissionCenterSettingModel,
  [WidgetModelNames.SupportSettingWidgetModel]:WidgetModelNames.SupportSettingWidgetModel,
  NoticeWidgetModel: 'NoticeWidgetModel'
}

export const GlobalModulesNames = [SettingModelNames.LoginSettingModel, SettingModelNames.LangSettingModel, SettingModelNames.ModuleNavigationWidgetModel, SettingModelNames.PwaWidgetModel, SettingModelNames.NoticeWidgetModel, WidgetModelNames.MissionCenterSettingModel, SettingModelNames.SupportSettingWidgetModel]

export const SpeModuleModelNamesMap = {
  [SupportSettingWidgetModel.name]:  ModuleNameEnum.CustomerService,
  [DialogWidgetModel.name]: ModuleNameEnum.Dialog,
  [MissionCenterSettingModel.name]: ModuleNameEnum.MissionCenter
}

export const GlobalWidgetModules = [ModuleNameEnum.CustomerService, ModuleNameEnum.Dialog, ModuleNameEnum.MissionCenter]

export const EditorWrapperClass = '.edit-content__center--wrapper'

export const ImageSizeListEnums = [
  {
    label: '充满',
    value: 'object-fill'
  },
  {
    label: '适应',
    value: 'object-contain'
  }
]
